/**
 * Human-readable labels for market session names (matches Statistics session tab).
 */

export function formatSessionDisplayName(sessionName: string): string {
  let formatted = sessionName;

  if (formatted.toLowerCase().startsWith("session:")) {
    formatted = formatted.substring(8).trim();
  }

  const PLACEHOLDER = "___NEWYORKPLACEHOLDER___";
  const hasNewYork = /new[_\-\/]york/i.test(formatted);
  if (hasNewYork) {
    formatted = formatted.replace(/new[_\-\/]york/gi, PLACEHOLDER);
  }

  const singleWordSessions = ["asian", "european", "us", "london", "tokyo", "sydney"];
  const foundSessions = singleWordSessions.filter((session) => formatted.toLowerCase().includes(session));

  const isCrossover = foundSessions.length >= 2 || (foundSessions.length >= 1 && hasNewYork);

  if (isCrossover) {
    while (formatted.includes(PLACEHOLDER)) {
      formatted = formatted.replace(PLACEHOLDER, "new york");
    }
    formatted = formatted.replace(/[_\//]/g, "-");
    const parts = formatted.split("-").filter((part) => part.trim().length > 0);
    formatted = parts
      .map((part) => {
        const trimmedPart = part.trim();
        if (trimmedPart.toLowerCase() === "new york") {
          return "New York";
        }
        return trimmedPart.charAt(0).toUpperCase() + trimmedPart.slice(1).toLowerCase();
      })
      .join("-");
  } else {
    while (formatted.includes(PLACEHOLDER)) {
      formatted = formatted.replace(PLACEHOLDER, "new york");
    }
    formatted = formatted.replace(/[-_\/]/g, " ");
    formatted = formatted
      .split(/\s+/)
      .filter((word) => word.length > 0)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  return formatted;
}
